import httpClient from "../../api/httpClient";
import ParceiroAgregado from "../classes/ParceiroAgregado";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET",  rota: "ParceiroAgregado/All" },
  { method: "GET",  rota: "ParceiroAgregado/{id}" },  
  { method: "POST", rota: "ParceiroAgregado/Adicionar" },
  { method: "PUT",  rota: "ParceiroAgregado/Atualizar" },
  { method: "POST", rota: "ParceiroAgregado/Apagar"},
];
                               
const apiServico: String = "PORTAL"

class ParceiroAgregadoDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  async Adicionar(value: ParceiroAgregado) {
    return await super.post(calls[2].rota, value);
  }

  async Atualizar(value: ParceiroAgregado) {
    return await super.put(calls[3].rota, value);
  }

  async Apagar(value: ParceiroAgregado) {
    return await super.post(calls[4].rota, value);
  }

  async ListarAtivos(codigoFornecedorSAP : Number): Promise<ParceiroAgregado[]> {
    return await super.Get(calls[0].rota + '/' + codigoFornecedorSAP )
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }
}
export default ParceiroAgregadoDataset;

